import './ScheduleEventName.scss';

const ScheduleEventName = ({ pageName, handleName, scheduleName }) => (
  <div className="schedule-event-name schedule-name-container">
    <div className="title">{pageName === 'Schedules' ? 'Schedule Name' : 'Event Name'}</div>
    <div className="schedule-input-container">
      <div className="schedule-name">
        <input
          placeholder={scheduleName}
          type="text"
          maxLength="30"
          onChange={(e) => handleName(e.target.value)}
        />
      </div>
    </div>
  </div>
);

export default ScheduleEventName;
